
import { Search } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { DocumentTable } from "./DocumentTable";
import { useTranslation } from "react-i18next";

interface Document {
  id: string;
  file_name: string;
  file_type: string;
  file_size: number;
  created_at: string;
  file_path: string;
}

interface DocumentLibraryProps {
  documents: Document[];
  isLoading: boolean;
  tenderId: string;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onDownload: (filePath: string, fileName: string) => void;
  onDelete?: (id: string, filePath: string) => void;
  onRefresh?: () => void;
}

export const DocumentLibrary = ({
  documents,
  isLoading,
  tenderId,
  searchQuery,
  onSearchChange,
  onDownload,
  onDelete,
  onRefresh,
}: DocumentLibraryProps) => {
  const { t } = useTranslation('offerManagement');
  
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle>{t('documents.library')}</CardTitle>
            <CardDescription>
              {t('documents.uploaded')}
            </CardDescription>
          </div>
          <div className="relative w-64">
            <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder={t('documents.search')}
              className="pl-8"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <DocumentTable
          documents={documents}
          isLoading={isLoading}
          tenderId={tenderId}
          onDownload={onDownload}
          onDelete={onDelete || (() => {})}
        />
      </CardContent>
    </Card>
  );
};
